import styled from "styled-components"

import { minWidth, maxWidth } from "utils"

export const Wrapper = styled.div`
  position: relative;
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;

  ::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    border-top: 3px solid #eee;
  }

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${maxWidth.tablet`
    justify-content: center;
  `}
`

export const Item = styled.div`
  width: calc(100% / 3);
  padding: 1.8rem 0 0;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: column;
  text-align: center;

  ${maxWidth.tablet`
    width: 50%;
  `}
`

export const ItemTitle = styled.p`
  width: 100%;
  margin: 0;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ItemText = styled.p`
  width: 100%;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const EmptyItem = styled.div`
  display: none;

  ${maxWidth.tablet`
    width: 50%;
    display: block;
  `}
`
